import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const App = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="app icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 4C4 1.79086 5.79086 0 8 0H16C18.2091 0 20 1.79086 20 4V20C20 22.2091 18.2091 24 16 24H8C5.79086 24 4 22.2091 4 20V4ZM6 5C6 4.44772 6.44772 4 7 4H17C17.5523 4 18 4.44772 18 5V19C18 19.5523 17.5523 20 17 20H7C6.44772 20 6 19.5523 6 19V5ZM11 21C10.4477 21 10 21.4477 10 22C10 22.5523 10.4477 23 11 23H13C13.5523 23 14 22.5523 14 22C14 21.4477 13.5523 21 13 21H11Z"
    />
  </svg>
)
